import styled from "styled-components"

import {ReactComponent as IconoLinkedIn } from '../../icons/linkedin.svg'
import {ReactComponent as IconoGithub } from '../../icons/github.svg'
import {ReactComponent as IconoDownload } from '../../icons/download.svg'

export default function Footer() {
    return (
        <Container>
            <ContactContainer>
                <IconoLinkedIn onClick={() => window.open("https://www.linkedin.com/in/feli-blanco/")} fill="#fff" style={{width: '28px', height:'28px'}}/>
                <IconoGithub onClick={() => window.open("https://github.com/FeliBlanco")} fill="#fff" style={{width: '26px', height:'26px'}}/>
                <IconoDownload fill="#fff" style={{width: '30px', height:'30px'}}/>
            </ContactContainer>
            <div>
                <span style={{fontSize:'12px'}}>Felipe Blanco &copy; 2024</span>
            </div>
        </Container>
    )
}

const ContactContainer = styled.div`
display:flex;
gap:10px;


& > * { 
    cursor:pointer;
    transition: all 0.2s;
}

& > *:hover {
    transform: scale(1.5);
}
`
const Container = styled.div`
display:flex;
flex-direction:column;
align-items:center;
padding:6px;
`